import { render, staticRenderFns } from "./ydy.vue?vue&type=template&id=8399cf32"
import script from "./ydy.vue?vue&type=script&lang=js"
export * from "./ydy.vue?vue&type=script&lang=js"
import style0 from "./ydy.vue?vue&type=style&index=0&id=8399cf32&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports